var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { updateAccountBadgeOptionsFunctionDef } from '../../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { Form } from '@juvare/common-form-ui/Form';
import { FormConfigContext } from '@juvare/common-form-ui/FormConfigContext';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Link } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useContext } from 'react';
import { NavLink } from 'react-router';
export const AccountBadgeDetailsEditDialog = ({ accountBadge, badgeElements, additionalOptionsFormElements, onClose, onSuccess, onMapFormDataToAccountBadgeOptions, }) => {
    const updateAccountBadgeOptions = useTypedPlatformFunction(updateAccountBadgeOptionsFunctionDef);
    const { valueProviders } = useContext(FormConfigContext);
    const { t } = useBadgingTranslation();
    const formRef = React.useRef(null);
    const formConfig = React.useMemo(() => ({
        type: 'form',
        children: [
            {
                type: 'form.select',
                key: 'organizationId',
                label: t('badges.badgeDetails.accountBadgeSlideout.editDetailsModal.selectOrganization'),
                valueProvider: {
                    type: 'accountOrganizations',
                    params: accountBadge.columns.accountId,
                },
            },
            ...(additionalOptionsFormElements !== null && additionalOptionsFormElements !== void 0 ? additionalOptionsFormElements : []),
        ],
    }), [t, accountBadge.columns.accountId, additionalOptionsFormElements]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('badges.badgeDetails.accountBadgeSlideout.badgeElements')),
        React.createElement(DialogContent, null,
            React.createElement(Grid, { container: true, sx: { background: themeColors.surface.secondary, p: 2, pt: 0, mb: 2 } },
                badgeElements.map(({ label, value }) => (React.createElement(Grid, { key: `account-element-${label}`, container: true, size: 12, sx: {
                        py: 2,
                        borderBottom: 1,
                        borderColor: themeColors.border.main,
                    } },
                    React.createElement(Grid, { size: 6 },
                        React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, label)),
                    React.createElement(Grid, { size: 6 },
                        React.createElement(Typography, { variant: 'subtitle2' }, value))))),
                React.createElement(Grid, { container: true, sx: { pt: 2 } },
                    React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, t('badges.badgeDetails.accountBadgeSlideout.editDetailsModal.canOnlyBeEditedFrom')),
                    React.createElement(Link, { component: NavLink, onClick: () => onClose(), state: { back: true }, to: `/accounts/${accountBadge.columns.accountId}` },
                        React.createElement(Typography, { variant: 'body2' },
                            t('badges.badgeDetails.accountBadgeSlideout.editDetailsModal.profilePage'),
                            ".")))),
            React.createElement(Form, { ref: formRef, hideFormControls: true, valueProviders: valueProviders, data: accountBadge.data.options, onSubmit: (data) => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        yield updateAccountBadgeOptions({
                            accountBadgeId: accountBadge.id,
                            accountBadgeOptions: onMapFormDataToAccountBadgeOptions(Object.assign(Object.assign({}, accountBadge.data.options), data)),
                        });
                        onClose();
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        showAlertSnackbar({
                            type: 'success',
                            message: t('badges.badgeDetails.accountBadgeSlideout.editDetailsModal.submitSuccess'),
                        });
                    }
                    catch (error) {
                        handleErrorSnackbar(error);
                    }
                }), config: formConfig })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => onClose() }, t('common.cancel')),
            React.createElement(Button, { onClick: () => { var _a; return void ((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit()); } }, t('common.save')))));
};
